const videoLightboxes = document.querySelectorAll<HTMLElement>(
	'.video-control[data-micromodal-trigger]'
);

window.MicroModal.init({ awaitOpenAnimation: true, awaitCloseAnimation: true });
if (videoLightboxes) {
	videoLightboxes.forEach((lightbox) => {
		lightbox.addEventListener('click', (e) => {
			e.preventDefault();
			if (lightbox.dataset.micromodalTrigger) {
				const modal = document.getElementById(lightbox.dataset.micromodalTrigger);
				if (!modal) return;

				// Handle MP4 video
				const videoElement =
					modal.querySelector<HTMLVideoElement>('.video-lightbox__video');
				if (videoElement) {
					const videoSrc = videoElement.getAttribute('data-src');

					if (videoSrc) {
						window.MicroModal.show(lightbox.dataset.micromodalTrigger, {
							awaitOpenAnimation: true,
							awaitCloseAnimation: true,
							disableScroll: true,
							onShow: () => {
								window.lenis?.stop();
								videoElement.src = videoSrc;
								videoElement.play();
							},
							onClose: () => {
								window.lenis?.start();
								videoElement.pause();
								videoElement.src = '';
							},
						});
					}
					return;
				}

				// Handle iframe embed (YouTube, Vimeo, Wistia)
				const iframe = modal.querySelector('iframe');

				if (iframe) {
					const videoSrc = iframe.getAttribute('data-src');

					if (videoSrc) {
						window.MicroModal.show(lightbox.dataset.micromodalTrigger, {
							awaitOpenAnimation: true,
							awaitCloseAnimation: true,
							disableScroll: true,
							onShow: () => {
								window.lenis?.stop();
								iframe.src = videoSrc;

								// Disable all no autoplay videos.
								document
									.querySelectorAll('.video-inline--no-autoplay')
									.forEach((container) => {
										const noAutoplayIframe =
											container.querySelector<HTMLIFrameElement>('iframe');

										if (noAutoplayIframe) {
											noAutoplayIframe.src = '';
											noAutoplayIframe.classList.remove('visible');
										}
									});
							},
							onClose: () => {
								window.lenis?.start();
								iframe.src = '';
							},
						});
					}
				}
			}
		});
	});
}
